import React from 'react';
import TimingIcon from './TimingIcon';
import T from 'i18n-react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import type { TimingType } from '../index';

const useStyles = makeStyles((theme) => ({
  iconContainer: {
    display: 'inline-block',
    marginRight: theme.spacing(1),
  },
  text: {
    marginRight: theme.spacing(2),
  },
}));

type TimingContentProps = {
  timing: TimingType,
};

const TimingContent = ({ timing }: TimingContentProps) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.iconContainer}>
        <TimingIcon timing={timing} />
      </div>
      <span className={classes.text}>
        {T.translate(`planPage.planMeals.timings.${timing}`)}
      </span>
    </>
  );
};

export default TimingContent;
